import configDB from '@data/customizer/config';
import { media } from '@styles/mediaQuery';
import styled from 'styled-components';

const primary = localStorage.getItem('default_color') || configDB.data.color.primary_color;

export const Button = styled.button`
  width: 100%;
  height: 44px;
  color: #fff;
  border-radius: 4px;
  font-weight: 700;
  font-size: 16px;
  border: none;
  word-break: keep-all;
  background-color: ${(props) => props.color};
  border: 1px solid ${(props) => (props.color === '#fff' ? '#ccc' : props.color)};
  color: ${(props) => (props.color === '#fff' ? '#222' : '#fff')};
`;

export const AddBtn = styled(Button)`
  width: 12%;
  margin-right: 0.6vw;
  color: ${primary};
  border: 1px solid ${primary};
  background-color: transparent;
  :active,
  :hover {
    background-color: ${primary};
    color: #fff;
  }
  transition: all 0.1s ease-in-out;

  ${media.tablet`
    width: 20%;
  `}
  ${media.mobile`
    font-size: 12px;
    width: 40%;
  `}
`;

export const Label1 = styled.label`
  width: fit-content;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  h5 {
    width: fit-content;
    font-size: 14px;
    strong {
      color: red;
    }
  }
  p {
    margin-bottom: 0;
    font-size: 12px;
    color: #555;
  }
  :not(:last-child) {
    margin-bottom: 15px;
  }
  input,
  textarea {
    margin-top: 0.3vw;
    padding: 6px 15px;
    background: #f8fcff;
    border: 1px solid #e9e9e9;
    border-radius: 4px;
    ::placeholder {
      color: #b0b0b0;
    }
    :active,
    :focus {
      border: 1px solid #05c8da;
    }
  }
  textarea {
    height: 15vh;
    resize: none;
  }
  .react-datepicker-wrapper {
    margin-top: 0.3vw;
  }
`;
